var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 36,
    height: 36,
    rx: 5,
    fill: "#003CCB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_167)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1185 9C12.3252 9 9.25 12.0752 9.25 15.8685C9.25 19.6619 12.3252 22.7371 16.1185 22.7371C17.7236 22.7371 19.2 22.1866 20.3693 21.2641L25.8817 26.7765C26.1798 27.0745 26.663 27.0745 26.961 26.7765C27.259 26.4784 27.259 25.9952 26.961 25.6972L21.4559 20.1921C22.4134 19.0115 22.9871 17.507 22.9871 15.8685C22.9871 12.0752 19.9119 9 16.1185 9ZM10.7763 15.8685C10.7763 12.9181 13.1681 10.5263 16.1185 10.5263C19.069 10.5263 21.4607 12.9181 21.4607 15.8685C21.4607 18.819 19.069 21.2107 16.1185 21.2107C13.1681 21.2107 10.7763 18.819 10.7763 15.8685Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9.25 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlue);
export default __webpack_public_path__ + "static/media/Search_Blue.b851e498fcd4e58026d56fcc3fe3ce05.svg";
export { ForwardRef as ReactComponent };